import NavBar from './navBar';
import allIn from '../../assets/ALL IN ONE.png'
import hiringPlatform from '../../assets/Your Hiring Platform.png'
import img1 from '../../assets/Component 10.png'
import img2 from '../../assets/Component 9.png'
import img3 from '../../assets/Component 8.png'
import img4 from '../../assets/Component 7.png'
import img5 from '../../assets/Component 6.png'
import img6 from '../../assets/Component 5.png'
import card1 from "../../assets/card1.svg"
import card2 from '../../assets/card2.png'
import card3 from '../../assets/card3.png'
import ellipse from '../../assets/Ellipse 1.png'
import first from "../../assets/Frame 16.png"
import second from "../../assets/Frame 4.png"
import third from "../../assets/Group 11.png"
import fourth from "../../assets/Group 12.png"
import fifth from "../../assets/Group 13.png"
import six from "../../assets/Group 14.png"
import seven from '../../assets/Screenshot 2025-02-20 at 1.20.42 AM 1.png'
import eigth from "../../assets/frame.png"
import imageone from '../../assets/image1.png'
import imagetwo from '../../assets/image2.png'
import searchinsight from '../../assets/search_insights.png'
import plus from '../../assets/+.png'
import shadow from '../../assets/shadow.png'
import square from '../../assets/stat_0.png'
import Footer from './Footer';
import ContactUs from './ContactUs';
import '../../styles/homeStyle.css'
import company1 from '../../assets/company1.png'
import company2 from '../../assets/comapny2.png'
import company3 from '../../assets/company3.png'
import company4 from '../../assets/company4.png'
import companyLogo1 from '../../assets/company1Logo.png'
import companyLogo2 from '../../assets/company2logo.png'
import companyLogo3 from '../../assets/company3Logo.png'
import companyLogo4 from '../../assets/company4Logo.png'
import arrow from '../../assets/Component 3.png'
import photo from '../../assets/Group139.png'
import onboarding from "../../assets/Frame9.png"


const LandingPage = () => {
    return (
        <>
            <NavBar /> 
            <section className='first-section'>
                <div className='first-section-container'>
                    <div className='first-section-divider'>
                        <div className='first-section-left'>
                            <div className='circle-container'>
                             <img src={ellipse} alt='ellipse' className='ellipse' />
                             <img src={six} alt='circle' className='circle-image fifth' />
                             <img src={fourth} alt='circle' className='circle-image third' />
                             <img src={fifth} alt='circle' className='circle-image seventh' />
                             <img src={third} alt='circle' className='circle-image second' />
                             <img src={first} alt='circle' className='circle-image fourth' />
                             <img src={second} alt='circle' className='circle-image sixth' />
                             <img src={eigth} alt='circle' className='circle-image eighth' />
                             <img src={imagetwo} alt='circle' className='circle-image image2' />
                             <img src={imageone} alt='circle' className='circle-image image1' />
                             <img src={photo} alt='circle' className='circle-image photo' />
                             <img src={square} alt='circle' className='circle-image square2' />
                             <img src={square} alt='circle' className='circle-image square' />
                             <img src={square} alt='circle' className='circle-image square-repeat' />
                             <img src={plus} alt='circle' className='circle-image plus' />
                             <img src={shadow} alt='circle' className='circle-image shadow' />
                             <img src={searchinsight} alt='circle' className='circle-image insight' />
                             <img src={onboarding} alt='circle' className='circle-image onboarding' />
                                  {/*  
                                <img src={seven} alt='circle' className='circle-image first' />
                                <img src={third} alt='circle' className='circle-image second' />
                                
                                */}
                            </div>
                        </div>
                        <div className='first-section-right'>
                        <p className='first-section-heading'>1800HIRED BUSINESS PLATFORM</p>
                            <div style={{ position: "relative" }}>
                                <img src={hiringPlatform} alt='hiringPlatform' className='hiring-platform' style={{width:"350px"}}/> <img src={allIn} className='all-in-one' alt='allInOne' />
                            </div>
                            <p className='first-section-right-desc'>Find the best talent globally and empower your team to
                                invest in talent
                                strategy and grow your company at scale.</p>
                            <div className='first-section-right-buttons'>
                                <button>Request a Demo</button>
                                <a href='/'>Explore 1800hired</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='second-section'>
                <div className='second-section-container'>
                    <div className='second-section-uppar-part'>
                        <p>See who’s hiring with <span style={{ color: "#3574D6", fontWeight: "700" }}>1800hired</span></p>
                        <p className='second-section-subheading'>See who all are onboard with us!</p>
                    </div>
                    <div className='second-section-lower'>
                        <img src={img1} alt='' className='second-section-images' />
                        <img src={img2} alt='' className='second-section-images' />
                        <img src={img3} alt='' className='second-section-images' />
                        <img src={img4} alt='' className='second-section-images' />
                        <img src={img5} alt='' className='second-section-images' />
                        <img src={img6} alt='' className='second-section-images' />
                    </div>
                </div>
            </section>
            <section className='third-section'>
                <div className='third-section-container'>
                    <p className='third-section-heading'><span style={{ color: "#2D76FD", fontWeight: "400" }}>Build</span> an experience candidate love</p>
                    <div className='third-section-cards'>
                        {[
                            {
                                img: card1,
                                title: "Dedicated to your success",
                                desc: "Advisory and technical support to help your organisation get the most value from 1800Hired and reach your hiring goals – faster.",
                                link: "/"
                            },
                            {
                                img: card2,
                                title: "Pillar to your hiring process",
                                desc: "“1800Hired is, without a doubt, the best ATS available on the market. Our team is super responsive and hands-on. ",
                                link: "/"
                            },
                            {
                                img: card3,
                                title: "Our goal is your data security",
                                desc: "Protecting your data is a top concern 1800Hired operating system safeguards you and your candidates’ critical information.",
                                link: "/"
                            }
                        ].map((card, index) => (
                            <div key={index} className='landing-page-card'>
                                <img src={card.img} alt={card.title} className='card-image' />
                                <h3 className='landing-card-title'>{card.title}</h3>
                                <p className='landing-card-desc'>{card.desc}</p>
                                <a href={card.link} className='card-link'>Learn more</a>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section className='fourth-section'>
                <div className='fourth-section-container'>
                    <p className='fourth-section-heading'><span style={{ fontWeight: "700", fontFamily: "Arial" }}>Explore Resumes</span> based on trending domains</p>
                    <div className='fourth-section-lists'>
                        {[
                            {
                                title: "Design Resumes",
                                link: "/"
                            },
                            {
                                title: "Data Analyst Resumes",
                                link: "/"
                            },
                            {
                                title: "MBA qualified  CVs",
                                link: "/"
                            },
                        ].map((card, index) => (
                            <div key={index} className='list'>
                                <p className='list-desc'>{card.title}</p>
                                <a href={card.link} className='list-link'>View All</a>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section className='fifth-section'>
  <div className='fifth-section-container'>
    <div className='fifth-left'>
      <p className='fifth-heading'>
        Talent based Hiring <br />
        <span style={{ fontWeight: '700' }}>Around the globe</span>
      </p>
      <p className='fifth-subheading'>
        Premium handpicked openings that you only get here with us!
      </p>
      <img src={arrow} alt='arrow' className='arrow-fifth'/>
    </div>

    {/* Right Section with Cards */}
    <div className='fifth-right'>
      {[
        {
          id: 1,
          image: company1,
          company: companyLogo1,
          name:'ycus - Senior Site Reliability Engineer - Kubernetes',
          location: 'Mumbai/Bangalo…',
          experience: '3 - 6 Years',
        },
        {
          id: 2,
          image: company2,
          company: companyLogo2,
          name:"Appian Developer",
          location: 'Mumbai/Hydera…',
          experience: '4 - 13 Years',
        },
        {
          id: 3,
          image: company3,
          company: companyLogo3,
          name:"Accolite - Java Full Stack Developer -…",
          location: 'Mumbai/Hydera…',
          experience: '5 - 13 Year',
        },
        {
          id: 4,
          image: company4,
          company: companyLogo4,
          location: 'Chennai/Bangalo',
          name:"Tiger Analytics - Senior Application Engineering",
          experience: '5+ Years',
        },
      ].map((job) => (
        <div className='card-fifth' key={job.id}>
          <img src={job.image} alt={`${job.image} logo`} className='companyImage'/>
          <img src={job.company} alt={`${job.company} logo`} className='companyLogo'/>
          <p className='name'>{job.name}</p>
          <div className='location-exp'>         
            <p className='location'>{job.location}</p>
          <p className='experience'>{job.experience}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

            <ContactUs />
            <Footer />
            </>
    )
}

export default LandingPage;